import { Grid, type GridProps } from '@mui/material';

/** Grid container with standard form spacing */
export default function FormGrid({ spacing = 2, ...props }: GridProps) {
  return <Grid container spacing={spacing} {...props} />;
}
